import { LegalPage } from "./LegalPage";

const p = (text: React.ReactNode) => (
    <p style={{ margin: "0 0 12px" }}>{text}</p>
);

const ul = (items: string[]) => (
    <ul style={{ margin: "8px 0 12px", paddingLeft: 20, display: "flex", flexDirection: "column", gap: 6 }}>
        {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>
);

const QA = ({ q, a }: { q: string; a: string }) => (
    <div style={{ marginBottom: 10 }}>
        <div style={{ fontWeight: 700, color: "#374151", marginBottom: 2 }}>{q}</div>
        <div>{a}</div>
    </div>
);

const SECTIONS = [
    {
        id: "responsable",
        title: "Responsable de sus datos",
        content: <>{p(<>
            <strong>HeyDoctor SAPI de CV</strong>, con domicilio en Av. Cuauhtémoc 271 int. 403, colonia Roma, Ciudad de México, C.P. 06760, es el responsable del uso y protección de sus datos personales.
        </>)}</>
    },
    {
        id: "finalidades",
        title: "¿Para qué usamos sus datos?",
        content: <>
            {p("Los datos personales que recabamos de usted los utilizaremos para las siguientes finalidades necesarias para el servicio que solicita:")}
            {ul(["Mercadotecnia o publicitaria", "Prospección comercial"])}
            {p("En caso de que no desee que sus datos personales se utilicen para estos fines secundarios, indíquelo enviando un correo a contacto@heydoctor.com.mx")}
            {p("La negativa para el uso de sus datos personales para estas finalidades no podrá ser motivo para negarle los servicios y productos que solicita o contrata con nosotros.")}
        </>
    },
    {
        id: "datos-utilizados",
        title: "¿Qué datos utilizamos?",
        content: <>
            {p("Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, utilizaremos los siguientes datos personales:")}
            {ul(["Datos de identificación", "Datos de contacto", "Datos sobre características físicas", "Datos de salud"])}
        </>
    },
    {
        id: "derechos-arco",
        title: "Derechos ARCO",
        content: <>
            {p("Usted tiene derecho a conocer qué datos personales tenemos de usted (Acceso), solicitar la corrección de su información personal (Rectificación), que la eliminemos de nuestros registros (Cancelación) y oponerse al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos ARCO.")}
            {p("Para el ejercicio de cualquiera de los derechos ARCO, envíe su solicitud a:")}
            <div style={{ background: "#f0f9fa", borderRadius: 10, padding: "14px 18px", border: "1.5px solid #d1f0f4", marginBottom: 12 }}>
                <a href="mailto:contacto@heydoctor.com.mx" style={{ color: "#4abcc9", fontWeight: 700 }}>contacto@heydoctor.com.mx</a>
            </div>
            <QA q="¿Cómo acreditar su identidad?" a="Por correo electrónico a contacto@heydoctor.com.mx" />
            <QA q="¿Qué información deberá contener la solicitud?" a="Nombre, dirección, correo, representante legal en su caso, datos de contacto." />
            <QA q="¿En cuántos días daremos respuesta?" a="15 días hábiles." />
            <QA q="¿Por qué medio comunicaremos la respuesta?" a="Por correo electrónico desde directiva@amv.org.mx" />
            <QA q="¿En qué medios se pueden reproducir sus datos?" a="Página web www.heydoctor.com.mx, redes sociales (Facebook, Twitter, Instagram, LinkedIn, TikTok, entre otras), publicidad en línea y física." />
        </>
    },
    {
        id: "responsable-arco",
        title: "Contacto de datos personales",
        content: <>
            {p("Los datos de contacto del departamento de datos personales son:")}
            <div style={{ background: "#f8fbff", borderRadius: 10, padding: "14px 18px", border: "1.5px solid #eef2f7", fontSize: "0.88rem", display: "flex", flexDirection: "column" as const, gap: 4 }}>
                <div><strong>Responsable:</strong> Rodrigo Romero Feregrino</div>
                <div><strong>Domicilio:</strong> Av. Cuauhtémoc 271 int. 403, Col. Roma, CDMX, C.P. 06700</div>
                <div><strong>Correo:</strong> <a href="mailto:contacto@heydoctor.com.mx" style={{ color: "#4abcc9" }}>contacto@heydoctor.com.mx</a></div>
            </div>
        </>
    },
    {
        id: "revocacion",
        title: "Revocación del consentimiento",
        content: <>
            {p("Usted puede revocar el consentimiento que nos haya otorgado para el tratamiento de sus datos personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos atender su solicitud de forma inmediata, ya que por alguna obligación legal podríamos seguir tratando sus datos personales.")}
            {p("Para revocar su consentimiento, envíe su solicitud a: contacto@heydoctor.com.mx")}
            <QA q="¿Cómo acreditar su identidad?" a="Por correo electrónico a contacto@heydoctor.com.mx" />
            <QA q="¿Qué información deberá contener la solicitud?" a="Nombre, dirección, datos de contacto, representante legal en su caso." />
            <QA q="¿En cuántos días daremos respuesta?" a="15 días hábiles." />
            <QA q="¿Por qué medio comunicaremos la respuesta?" a="Por correo electrónico." />
        </>
    },
    {
        id: "cambios",
        title: "Cambios en este aviso",
        content: <>
            {p("El presente aviso de privacidad puede sufrir modificaciones derivadas de nuevos requerimientos legales, de nuestras propias necesidades por los productos o servicios que ofrecemos, de nuestras prácticas de privacidad o de cambios en nuestro modelo de negocio.")}
            {p("Nos comprometemos a mantenerlo informado sobre los cambios a través de: envío del nuevo aviso de privacidad por correo electrónico a los usuarios registrados en la plataforma HeyDoctor.")}
        </>
    },
    {
        id: "consentimiento",
        title: "Su consentimiento",
        content: <>{p("Al utilizar la plataforma HeyDoctor, consiente que sus datos personales sean tratados de conformidad con los términos y condiciones informados en el presente aviso de privacidad.")}</>
    },
];

export default function AvisoPrivacidadPage() {
    return (
        <LegalPage
            badge="Documento Legal"
            title="Aviso de Privacidad"
            subtitle="Tu privacidad es nuestra prioridad. Aquí describes cómo recopilamos, usamos y protegemos tus datos personales conforme a la ley."
            icon="shield"
            sections={SECTIONS}
        />
    );
}
